(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsc-first-ride"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tsc-first-ride')) { customElements.define('tsc-first-ride', class extends HTMLElement {
 connectedCallback() {
  if(this.controller) return;
  this.controller=new AbortController(); const {signal}=this.controller;
  this.dialog=this.querySelector('dialog');
  this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),{signal});
  this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}},{signal});
  this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.previousOverflow||'';this.querySelector('.tsc-fr-claim').focus();},{signal});
  const params=new URLSearchParams(location.search); const claimed=params.get('claimed')==='1';
  const expire=()=>{let end=this.dataset.endsAt;const config=document.getElementById('tsc-first-ride-config');if(config){try{end=JSON.parse(config.textContent).endsAt||end;}catch{}}const expired=Date.now()>=Date.parse(end);this.querySelector('[data-claim-form]').hidden=expired;this.querySelector('[data-offer-ended]').hidden=!expired;if(expired&&this.dialog.open)this.dialog.close();return expired;};
  if(claimed&&!expire()){this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';this.dialog.showModal();params.delete('claimed');history.replaceState(null,'',location.pathname+(params.size?'?'+params.toString():'')+location.hash);}
  this.timer=setInterval(expire,60000);expire();
 }
 disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.controller=null;if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.previousOverflow||'';}}
});}

  } catch(e) { console.error(e); }
})();
})();
